<template>
  <div>
    <validation-observer ref="refFormObserver">
      <b-form>
        <div class="mb-1">
          <h6>CCTV</h6>
          <b-button variant="secondary" @click="goToDeviceWizard('hanwhaDvr')">
            <span class="text-nowrap text-capitalize">{{`${$t("actions.add")} CCTV`}}</span>
          </b-button>
          <b-list-group class="mt-1">
            <b-list-group-item
              class="cursor-pointer"
              @click="goToEditDeviceWizard('hanwhaDvr', dvr)"
              v-for="dvr in hanwhaDvrs"
              :key="dvr.id">
              {{ dvr.name }}
            </b-list-group-item>
          </b-list-group>
        </div>

        <div class="">
          <h6>Panel</h6>
          <b-button variant="secondary" @click="goToDeviceWizard">
            <span class="text-nowrap text-capitalize">{{`${$t("actions.add")} ${$tc("dmp.title", 1)}`}}</span>
          </b-button>
          <b-list-group class="mt-1">
            <b-list-group-item
              class="cursor-pointer"
              @click="goToEditDeviceWizard('dmpPanel', panel)"
              v-for="panel in dmpPanels"
              :key="panel.id">
              {{ panel.name }}
            </b-list-group-item>
          </b-list-group>
        </div>

      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import formValidation from "@/@core/comp-functions/forms/form-validation";
import { ref, watch } from "@vue/composition-api";
import store from '@/store'

export default {
  name: "EmergencyContacts",
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    isAdd: {
      type: Boolean,
      default: false,
    },
    propItemData: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { refFormObserver, getValidationState } = formValidation();

    const itemData = ref({
      ...props.propItemData,
    });
    const hanwhaDvrs = ref([])
    const dmpPanels = ref([])

    const goToDeviceWizard = (device) => {
      const wizardData = encodeURIComponent(
        JSON.stringify(props?.propItemData)
      );
      let wizardUrl = `${window.location.origin}/#/dmp/panels?wizardData=${wizardData}`;

      if(device === "hanwhaDvr") {
        wizardUrl = `${window.location.origin}/#/hanwha_dvr?wizardData=${wizardData}`;
      }
      window.open(wizardUrl);
    };

    const goToEditDeviceWizard = (deviceType, device) => {
      const data = { ...device, isEdit: true }
      const wizardData = encodeURIComponent(
        JSON.stringify(data)
      );
      let wizardUrl = `${window.location.origin}/#/dmp/panels?wizardData=${wizardData}`;

      if(deviceType === "hanwhaDvr") {
        wizardUrl = `${window.location.origin}/#/hanwha_dvr?wizardData=${wizardData}`;
      }
      window.open(wizardUrl);
    };

    // Validación del paso
    const validateStep = async () => {
      return await refFormObserver.value.validate();
    }

    const getHanwhaDvrs = async () => {
      store.dispatch('hanwha_dvr/getAll', {
      max: 20,
      id_unit: itemData.value?.id,
    })
      .then(response => {
        hanwhaDvrs.value = response.data
      })
      .catch(() => {
        // toast({
        //   component: ToastificationContent,
        //   props: {
        //     title: 'Error obteniendo la información',
        //     icon: 'AlertTriangleIcon',
        //     variant: 'danger',
        //   },
        // })
      })
    }

    const getDmpPanels = async () => {
      store.dispatch('dmp_panels/getAll', {
        max: 20,
        units: itemData.value?.id,
      })
      .then(response => {
        dmpPanels.value = response.data
      })
      .catch(() => {
      })
    }

    getHanwhaDvrs();
    getDmpPanels()

    return {
      dmpPanels,
      hanwhaDvrs,
      itemData,
      refFormObserver,
      validateStep,
      goToDeviceWizard,
      getValidationState,
      goToEditDeviceWizard
    };
  },
};
</script>
